import { useTheme } from "@mui/material";

import { DonutChart } from "components/modules/charts/DonutChart";
import { useDDFilter } from "components/modules/disinfectionFilter/DisinfectionFilterPanel";
import { graphql } from "gql";
import { DisinfectionFilter } from "gql/graphql";
import { FormattedMessage } from "react-intl";
import { useQueryWithSnack } from "utils/useQueryWithSnack";

const QUERY = graphql(`
  query disinfectionsCompleted($filter: DisinfectionFilter!) {
    disinfectionsComplete(filter: $filter) {
      complete
      incomplete
    }
  }
`);

interface Props {
  hiddenFilter?: DisinfectionFilter;
}

export const CompletionChart = ({ hiddenFilter }: Props) => {
  const theme = useTheme();

  const [filterParams] = useDDFilter();

  const { data } = useQueryWithSnack(QUERY, {
    variables: {
      filter: {
        ...filterParams,
        ...hiddenFilter,
      },
    },
    skip: !filterParams?.timeSpan,
  });

  return (
    <DonutChart
      header={
        <FormattedMessage
          id="disinfections-completed"
          defaultMessage="Disinfections Completed"
        />
      }
      description={
        <FormattedMessage
          id="disinfections-completed-description"
          defaultMessage='"Completion Rate" - Disinfections completed successfully'
        />
      }
      count={data?.disinfectionsComplete.complete ?? 0}
      totalCount={
        (data?.disinfectionsComplete.complete ?? 0) +
        (data?.disinfectionsComplete.incomplete ?? 0)
      }
      paperProps={{
        style: {
          backgroundColor: theme.palette.success.main,
        },
      }}
      paperTextColor="white"
      donutSize={112}
      donutColor="white"
      donutBackgroundColor="rgba(24, 28, 50, 0.05)"
      donutTextColor="white"
      dataUnknown={data === undefined}
    />
  );
};
